import { createIcon } from "@chakra-ui/react";

export const FolderOpen = createIcon({
  displayName: "FolderOpen",
  viewBox: "0 -960 960 960",
  d: "M170.001-180.001q-29.154 0-49.577-20.423t-20.423-49.577v-457.69q0-29.154 21.577-50.731t50.731-21.577h219.613l80 80h315.769q26.846 0 46.307 17.346Q853.46-665.307 856.537-640H447.385l-80-80H172.309q-5.385 0-8.847 3.462-3.462 3.462-3.462 8.847v455.382q0 4.231 2.116 6.924 2.115 2.692 5.577 4.616L261-552.307h666.307l-96.846 322.614q-6.846 22.538-25.654 36.115-18.807 13.577-41.73 13.577H170.001zM230.537-240H770.77l75.462-252.309H305.999L230.537-240zm0 0l75.462-252.309L230.537-240zM160-640v-80 80z",
});
